import { IPreloadedState } from 'shared/types/redux';

export const selectSearchMetaData = (state: IPreloadedState) => state.searchMeta.data;
